<div class="page">
    
    <div class="page-name">Picklist admin</div><br>
    <ng-container *ngIf="!pickListCategoriesList || loadingData">
        <div class="row">
            <div class="skeleton col-md-2 " style="height: calc(100vh - 190px)"></div>
            <div class="skeleton col-md-9 mx-5" style="height: calc(100vh - 190px)"></div>
        </div>
    </ng-container>
<div class="row" *ngIf="pickListCategoriesList">
    <div class="col-md-12">
        
        <!-- <div class="row">
            <div class="col-md-12">
                <div class="d-flex" id="picklistCategory">
                    <div class="key">Category:</div>
                    <div class="issue">
                        <dx-drop-down-box
                            class="field-input"
                            [dataSource]="categoryGroupList"
                            stylingMode="outlined"
                            [readOnly]="false"
                            [value]="selectedValue"
                            valueExpr="categoryId"
                            displayExpr="value"
                        >
                            <dx-list
                                [dataSource]="categoryGroupList"
                                displayExpr="value"
                                valueExpr="categoryId"
                                selectionMode="single" 
                                (onSelectionChanged)="changePickListCat($event)"
                            >
                            </dx-list>
                        </dx-drop-down-box>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="row">
            <div class="col-12 my-2">
                <div class="row">
                    <div class="col-md-2">
                        <div class="title-list-sec left-col">
                            <dx-list #picklistCategory 
                            [dataSource]="pickListCategoriesList" 
                            [selectionMode]="'single'"
                            (onSelectionChanged)="onSelect($event)"
                            [showSelectionControls]="false" 
                            [selectedItemKeys]="pickListCategoriesList[0]"
                            displayExpr="type">
                            </dx-list>
                        </div>
                    </div>
                    <div class="col-md-9 mx-5 title-list-sec">
                        <div *ngIf="!vendorSelect">
                            <dx-data-grid 
                            #picklistGrid
                            height="calc(100vh - 190px)"
                            id="picklistData"
                            class="grid-with-header picklist-admin"
                            (onInitNewRow)="onAdd($event)"
                            [dataSource]="pickListAdmin" 
                            [showBorders]="true"
                            (onEditingStart)="onEditingStart($event)"
                            (onSaved)="updatePickListCategory($event, pickListAdmin)">
    
                            <dxo-editing mode="row" 
                            [allowDeleting]="allowDelete" 
                            [allowUpdating]="allowUpdate" 
                            [allowAdding]="isAdminOrFinExec" 
                            [useIcons]="true">
                            </dxo-editing>
                            <dxo-paging [pageSize]="100000" emptyPanelText=""></dxo-paging>
    
                            <dxi-column caption="Display Order" class="text-left" dataField="displayOrder" width="25%">
                                <dxi-validation-rule type="required"></dxi-validation-rule>
                                <dxi-validation-rule
                                type="custom"
                                message="Display Order is not unique, Please enter a different order number."
                                [validationCallback]="detailsOrderValidation"
                              ></dxi-validation-rule>
                            </dxi-column>
                            <dxi-column caption="Value" dataField="value" dataType="string" width="45%">
                                <dxi-validation-rule type="required"></dxi-validation-rule>
                                <dxi-validation-rule
                                type="custom"
                                message="Value is not unique, Please enter a different value."
                                [validationCallback]="detailsNameValidation"
                              ></dxi-validation-rule>
                            </dxi-column>
                            <dxi-column caption="STATUS" class="text-center" dataField="deleteFlag" dataType="boolean" [allowEditing]="allowStatusEdit" width="10%">
                                <dxo-lookup 
                                [dataSource]="deleteStatusOptions" 
                                valueExpr="value" 
                                displayExpr="name">
                              </dxo-lookup></dxi-column>
                            </dx-data-grid>
                        </div>
                        <div *ngIf="vendorSelect">
                            <dx-data-grid 
                            #picklistGrid
                            height="calc(100vh - 190px)"
                            id="picklistData"
                            class="grid-with-header picklist-admin"
                            [dataSource]="VendorIdAdmin" 
                            (onInitNewRow)="onAdd($event)"
                            (onEditingStart)="onEditingStart($event)"
                            [showBorders]="true"
                            (onSaved)="updateVendorCategory($event)">
    
                            <dxo-editing mode="row" 
                            [allowDeleting]="allowDelete" 
                            [allowUpdating]="allowUpdate" 
                            [allowAdding]="isAdminOrFinExec"
                            [useIcons]="true">
                            </dxo-editing>
                            <dxo-paging [pageSize]="100000" emptyPanelText=""></dxo-paging>
    
                            <dxi-column caption="Display Order" class="text-left" dataField="displayOrder" width="25%">
                                <dxi-validation-rule type="required"></dxi-validation-rule>
                                <dxi-validation-rule
                                type="custom"
                                message="Display Order is not unique, Please enter a different order number"
                                [validationCallback]="vendorOrderValidation"
                              ></dxi-validation-rule>
                            </dxi-column>
                            <dxi-column caption="Name" dataField="name" dataType="string" width="45%">
                                <dxi-validation-rule type="required"></dxi-validation-rule>
                                <dxi-validation-rule
                                type="custom"
                                message="Name is not unique, Please enter a different value"
                                [validationCallback]="vendorNameValidation"
                              ></dxi-validation-rule>
                            </dxi-column>
                            <dxi-column caption="STATUS" class="text-center" dataField="deleteFlag" dataType="boolean" [allowEditing]="allowStatusEdit" width="10%">
                                <dxo-lookup 
                                [dataSource]="deleteStatusOptions"
                                valueExpr="value" 
                                displayExpr="name">
                              </dxo-lookup>
                            </dxi-column>
                        </dx-data-grid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
        
           
            
    </div>
    <!-- <app-confirmation-popup *ngIf="openConfirmationPopup" [option]="confirmationPopupOption"
    (onConfirmed)="confirmationChanges($event)"></app-confirmation-popup> -->

    <app-load-panel *ngIf="showLoadPanel" [option]="loadPanelOption"></app-load-panel>